import { config } from "@/lib/config";

/**
 * Welche Anmeldewege die Instanz wirklich kann.
 *
 * Der Anmeldebildschirm hat lange beide Knöpfe gezeigt, Apple sogar als den
 * auffälligeren. Apple war bei GoTrue aber nie eingerichtet, und wer darauf
 * tippte, landete auf einer weißen Seite mit
 * {"error_code":"validation_failed","msg":"Unsupported provider"}. Das ist
 * kein Fehler, den jemand von außen deuten kann.
 *
 * GoTrue sagt selbst, was es anbietet. Die App fragt das und zeigt nur, was
 * geht. Wird Apple später eingerichtet, erscheint der Knopf von allein, ohne
 * neue Fassung der App.
 */
export interface Anbieter {
  apple: boolean;
  google: boolean;
}

const SPEICHER = "ainkauf.anbieter";

function ausSpeicher(): Anbieter | null {
  try {
    const roh = globalThis.localStorage?.getItem(SPEICHER);
    if (!roh) return null;
    const gelesen = JSON.parse(roh) as Partial<Anbieter>;
    return { apple: gelesen.apple === true, google: gelesen.google === true };
  } catch {
    return null;
  }
}

export async function verfuegbareAnbieter(): Promise<Anbieter> {
  const { supabaseUrl, supabaseAnonKey } = config();

  try {
    const antwort = await fetch(`${supabaseUrl}/auth/v1/settings`, { headers: { apikey: supabaseAnonKey } });
    if (!antwort.ok) throw new Error(String(antwort.status));

    const daten = (await antwort.json()) as { external?: Record<string, boolean> };
    const gefunden: Anbieter = {
      apple: daten.external?.apple === true,
      google: daten.external?.google === true,
    };

    globalThis.localStorage?.setItem(SPEICHER, JSON.stringify(gefunden));
    return gefunden;
  } catch {
    // Kein Netz oder Instanz gerade stumm: der zuletzt bekannte Stand. Ohne
    // jeden Stand beide anbieten, das ist nicht schlechter als vorher.
    return ausSpeicher() ?? { apple: true, google: true };
  }
}
